import map from 'lodash/map';
import get from 'lodash/get';
import React from 'react';
import s from './Breadcrumb.module.scss';
import { BreadcrumbSchema } from '../../components/Schemas';
import { getBreadcrumbSchemaUrl } from '../../services/urlCreator';
import Link from '../Link/Link';
import { host } from '../../config/urlConfig';

interface BreadcrumbProps {
	ancestors: { url: string; label: string; anchorTag?: boolean }[];
}

const Breadcrumb = (props: BreadcrumbProps) => {
	const { ancestors = [] } = props;
	const bAncestors = [
		{
			url: host,
			label: 'Home',
		},
		{
			url: '',
			label: 'Movie Tickets',
		},
		...ancestors,
	];
	const ancestorsCount = get(bAncestors, 'length');
	return (
		<div className={s.breadcrumb}>
			<BreadcrumbSchema
				items={map(bAncestors, (ancestor, index) => ({
					name: ancestor.label,
					item: {
						'@type': 'Thing',
						'@id': index === 0 ? ancestor.url : getBreadcrumbSchemaUrl(ancestor.url),
					},
				}))}
			/>
			{map(bAncestors, (ancestor, index) => {
				const { url, label, anchorTag } = ancestor;
				return index == ancestorsCount - 1 ? (
					<span key={index}>{label}</span>
				) : (
					<React.Fragment key={index}>
						{anchorTag ? <a href={url}>{label}</a> : <Link to={url}>{label}</Link>}
						<div className={s.planArrow}>
							<i className={s.right} />
						</div>
					</React.Fragment>
				);
			})}
		</div>
	);
};

export default Breadcrumb;
